

import React from "react";
import {
  Page,
  Content,
  PageText,
  AboutContent,
  Topic,
  Technology,
  University,
  Degree,
  Modules,
  Position,
  Company,
  Location
} from "./Styles";


function About(){

   return (
    <section>
        <Page>
          <Content> 
            <PageText>About</PageText>
            <AboutContent> I am working with MERN stack for now and I love writing codes in new programming languages.I am an experienced professional having experience in Computional Science and Data Science looking for an opportunity to work in technically challenged environments.Besides Tamil (my native language),I speak English with professional proficiency levels and French with basic proficiency levels.I currently live in Vellore,India.I have previously lived in the United Kingdom and France. Currently, I am looking to join as Senior Software Engineer - Javascript , Data Scientist and Research Software Engineer positions.
            </AboutContent> 

            <PageText>Technologies</PageText>
            <Topic>Programming Languages</Topic>
            <Technology> HTML5, CSS3, Java, Python, JavaScript, SQL, R, Web API </Technology>
            <Topic>Frameworks/Libraries</Topic>
            <Technology> ReacJS, ExpressJS, NodeJS, Django, Sci-kit learn, Pandas </Technology>
            <Topic>Databases</Topic>
            <Technology> MySQL, NoSQL-MongoDB , AWS-S3 </Technology>
            <Topic>Data Sciences</Topic>
            <Technology> Python Scientific Computing Librabries, MicroStrategy, Talend, Renku.io, RStudio, SPSS </Technology>

            <PageText>Education</PageText>
            <Degree>Bachelor of Engineering - Computer Science and Engineering (2007-2011)</Degree>
            <University> Anna University, Chennai, India </University>
            <Modules> Modules : Computer Science, Electrical and Electronics, Mathematics and Management.
            </Modules> 
            <Degree>Post Graduate Certificate - Advanced Computer Science (2013-2014)</Degree>
            <University> University of Leicester, Leicester, United Kingdom </University>
            <Modules> Modules :  Service Oriented Architectures, Financial Services Information Systems, Advanced System Design, Personal and Group Skills.
            </Modules> 
            <Degree>Master of Science - Business Intelligence and Analytics attended(2018-2019)</Degree>
            <University> ESC School of Management, Clermont Ferrrand, France </University>
            <Modules> Modules : Advanced Data Modeling, Data Discovery, Data Visualization, Qualitative data and Quantitative data, BI Organization, BI Methodology, BI Fundamentals, BI Segmentation,Strategic Management and Information Systems, Thesis Methodology.
            </Modules>  

            <PageText>Experience</PageText> 
            <Position>Co-Founder and CEO (2021-Present)</Position> 
            <Company>Company : Emperor Technology Labs </Company> 
            <Location>Location : Birmingham, United Kingdom.</Location> 
            <Position>Program Management Associate Intern (2020-2021)</Position> 
            <Company>Company : Uniglow - Consulting And Training </Company> 
            <Location>Location : Leicester, United Kingdom.</Location> 
            <Position>Product Tester (2017-2018)</Position> 
            <Company>Company : Vectone India Private Services Limited </Company> 
            <Location>Location : Chennai, India.</Location> 
            <Position>Software Developer Advocate (2015-2017)</Position> 
            <Company>Company : Emperor Technology Labs </Company> 
            <Location>Location : Birmingham, United Kingdom.</Location> 
            <Position> Promotion Executives (2013-2015)</Position> 
            <Company>Company : jSoft Private Solutions Limited </Company> 
            <Location>Location : London, United Kingdom.</Location>         
          </Content>
        </Page>
    </section>
    )
}
           
export default About;
